import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('customer-data-objects', {
  library: 'customer-data-objects'
});